import React from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorOutline } from '@mui/icons-material'
import { Box, Chip } from '@mui/material'

const GameRemovedFromAppStoreWarning: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box display="flex" justifyContent="center">
      <Chip icon={<ErrorOutline />} className="Chip Chip--warning" label={t('common:game_removed_from_app_store')} variant="outlined" />
    </Box>
  )
}

export default GameRemovedFromAppStoreWarning
